export const visit = (vm, at) => {
at({ "ja": { "featureTables": { "compare": { "screenReader": { "featureAvailable": "\u4F7F\u7528\u3067\u304D\u308B\u6A5F\u80FD", "featureUnavailable": "\u4F7F\u7528\u3067\u304D\u306A\u3044\u6A5F\u80FD" } } } } });
};